// src/modules/app-views/toolbox/seed.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';
import { generateUidV4 } from 'utils/helpers';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEFAULT_SEEDS = {
  units: [
    {
      uid: generateUidV4(),
      name: 'UN',
      description: 'Unidade',
    },
  ],
  sku: {
    autoSku: 'alpha6',
  },
};

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
async function seedToolboxParameters({ moduleId, storedParameters }) {
  if (!moduleId) return;

  const moduleParams = storedParameters?.modules?.[moduleId];
  const results = [];

  // Seed units if none exist
  const unitsResult = await seedCategory({
    moduleId,
    category: 'units',
    currentData: moduleParams?.units,
    defaultData: DEFAULT_SEEDS.units,
  });
  if (unitsResult) results.push(unitsResult);

  // Seed SKU settings if none exist
  const skuResult = await seedSku({
    moduleId,
    currentData: moduleParams?.sku,
    defaultData: DEFAULT_SEEDS.sku,
  });
  if (skuResult) results.push(skuResult);

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedToolboxParameters;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function checkHasActiveItems(dataArray) {
  if (!dataArray || !Array.isArray(dataArray)) return false;
  return dataArray.some(item => !item.removed);
}

async function seedSku({ moduleId, currentData, defaultData }) {
  // Skip if SKU settings already exist
  if (currentData?.autoSku) {
    return null;
  }

  try {
    await appService.updateModulePreferences({
      category: 'sku',
      moduleId,
      data: defaultData,
    });

    return { category: 'sku', seeded: true, data: defaultData };
  } catch (error) {
    console.error('[seedToolboxParameters] Error seeding sku:', error);
    return { category: 'sku', seeded: false, error };
  }
}

async function seedCategory({ moduleId, category, currentData, defaultData }) {
  const hasActiveItems = checkHasActiveItems(currentData);

  if (hasActiveItems) {
    return null; // Already has data, skip seeding
  }

  try {
    await appService.updateModulePreferences({
      category,
      moduleId,
      data: defaultData,
    });

    return { category, seeded: true, data: defaultData };
  } catch (error) {
    console.error(`[seedToolboxParameters] Error seeding ${category}:`, error);
    return { category, seeded: false, error };
  }
}
